import { Address } from "./address";
import { ProductDocument } from "./productdocument";

export class OrderDetails {
    public address :Address;
    public documentlist: Array<ProductDocument>;
}